import { contentPages } from './navigation';
import { pageMetadata, siteSeo, structuredData, applyMetadata } from './seo';
export function contentMetadata(path) {
  const page = contentPages[path];
  return page ? { ...pageMetadata(), title: `${page.seoTitle || page.title} | ${siteSeo.siteName}`, description: page.description, canonical: siteSeo.origin + path } : pageMetadata();
}
export function applyContentMetadata(path) {
  const meta=contentMetadata(path);
  applyMetadata(meta,structuredData(null,{route:path,title:meta.title,description:meta.description}));
}
